// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LabelledSwatchSelect{display:-webkit-box;display:-ms-flexbox;display:flex;flex-direction:column;}.LabelledSwatchSelect .LabelledSwatchSelect__heading{font-size:13px;text-transform:uppercase;opacity:.4}.LabelledSwatchSelect .LabelledSwatchSelect__swatches{margin:0.75rem 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
